
















































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import UpdateRateSourceRequest from '@/models/Products/RateSources/UpdateRateSourceRequest';
import RateSource from '@/models/Products/RateSources/RateSource';

@Component({ name: 'RateSourceEdit' })
export default class extends SaascadaVueDialog {

    request: UpdateRateSourceRequest = new UpdateRateSourceRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            await RateSourceModule.getRateSourcesForDialog();
        }
    }

    get currentRateSourceBaseRate() {
        return RateSourceModule.rateSource.baseRate;
    }

    get baseRateSourceOptions() {
        // Get all rate sources where baseRate is set to true
        return RateSourceModule.rateSourcesForDialog.filter((rateSource: RateSource) => (rateSource.baseRate));
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await RateSourceModule.editRateSourceDetails(this.request);
        }
    }

}
